module.exports = __webpack_public_path__ + "86f890a78cda325d7d11946383d762df.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/owl-store-dollars-s.png
// module id = 2568
// module chunks = 0